import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutProgressCard = ({ value = 75, label = 'Progress' }) => {
    const percentage = Math.min(Math.max(value, 0), 100); // Clamp between 0-100

    const data = {
        datasets: [
            {
                data: [percentage, 100 - percentage],
                backgroundColor: ['#ffffff', '#ffffff'], // Progress color, Background stroke color
                borderWidth: 0,
                cutout: '75%', // donut thickness
            },
        ],
    };

    const options = {
        cutout: '75%',
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
        },
    };

    return (
        <Card sx={{ width: 250, height: 150, display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white',  background: 'linear-gradient(135deg, #a8d4ff 0%, #478ed1 100%)' }}>
            <CardContent>
                <Box sx={{ position: 'relative', width: 120, height: 120, margin: '0 auto', }}>
                    <Doughnut data={data} options={options} />
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                        }}
                    >
                        <Typography sx={{color: 'white',}} variant="h6" component="div">
                            {percentage}%
                        </Typography>
                        <Typography sx={{color: 'white',}} variant="body2" color="text.secondary">
                            {label}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default DoughnutProgressCard;
